<template>
    <tr>
        <td class="text-center">
            <span class="ix-drag-icon handle-line"></span>
        </td>
        <td class="text-center">
            <input type="checkbox" value="1" :id="'is_title_' + deliveryLine.uniq" :name="'delivery_lines[' + index + '][is_title]'" v-model="deliveryLine.is_title" @change="compute" :disabled="deliveryLine.is_eco_participation">
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'delivery_lines[' + index + '][reference]'" v-model="deliveryLine.reference" :readonly="deliveryLine.is_eco_participation">
        </td>
        <td>
            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" :id="'suggestionAutocomplete' + deliveryLine.uniq" type="text" :name="'delivery_lines[' + index + '][designation]'" v-model="deliveryLine.designation" @input="emitEventLineEdited" :readonly="deliveryLine.is_eco_participation">
            <input type="hidden" :name="'delivery_lines[' + index + '][id]'" v-model="deliveryLine.id">
            <input type="hidden" :name="'delivery_lines[' + index + '][line_id]'" v-model="deliveryLine.line_id">

            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" placeholder="description, informations complémentaires, .." :name="'delivery_lines[' + index + '][description]'" v-model="deliveryLine.description"></textarea>
            </div>
        </td>
        <td v-if="deliveryLine.is_title == 1"></td>

        <td v-if="deliveryLine.is_title != 1">
            <input type="number" class="form-control form-control-sm" :name="'delivery_lines[' + index + '][quantity]'" v-model="deliveryLine.quantity" required step="0.001" :readonly="deliveryLine.is_eco_participation">
            <input type="text" class="form-control form-control-sm mt-2" placeholder="unité" :name="'delivery_lines[' + index + '][unit]'" v-model="deliveryLine.unit" v-show="is_expanded === true">
        </td>
        <td class="text-right">
            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>

            <span class="btn btn-sm transparent" @click="emitEventLineDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";

    export default {
        name: 'delivery-line-form',
        props: ['deliveryLine', 'index', 'suggestionsRoute'],
        data() {
            return {
                errors: [],
                is_expanded: false,
                suggestions: []
            };
        },
        methods : {
            expandRow: function() {
                this.is_expanded = !this.is_expanded;
            },
            compute: function() {
                // Prévention champs vide
                if (this.deliveryLine.quantity == '' || this.deliveryLine.quantity == null) { this.deliveryLine.quantity = 0 }

                if (this.deliveryLine.is_title) {
                    this.deliveryLine.quantity = 1;
                    this.deliveryLine.unit = null;
                }
            },
            emitEventLineEdited: function () {
                this.$emit('line-editing-started', this.index)
            },
            emitEventLineDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('line-deleted', this.index)
                    }
                })
            }
        },
        mounted() {
            // Expand si description
            if (this.deliveryLine.description) {
                this.is_expanded = true;
            }

            this.compute()

            // Creation autocomplete
            $("#suggestionAutocomplete" + this.deliveryLine.uniq).autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.suggestionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {...{ q: request.term }, ...{order_id: $('#order_id').val()}},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.autocomplete_label}</span>`;

                        if (item.is_title) {
                            html += `</div>`
                        } else {
                            html += `<span class="ml-auto">Qté : ${item.quantity}</span>
                                    </div>`
                        }

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        this.deliveryLine.line_id = null
                    }
                },
                select: (e, item) => {
                    this.deliveryLine.reference = item.item.reference
                    this.deliveryLine.designation = item.item.designation
                    this.deliveryLine.quantity = item.item.quantity
                    this.deliveryLine.unit = item.item.unit
                    this.deliveryLine.description = item.item.description
                    this.deliveryLine.is_title = item.item.is_title
                    this.deliveryLine.line_id = item.item.id
                }
            }).focus(() => {
                $("#suggestionAutocomplete" + this.deliveryLine.uniq).autocomplete("search", '');
            });
        }
    }
</script>
